var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 138,
    viewBox: "0 0 114 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9277 128.928C88.368 128.928 113.855 103.44 113.855 72C113.855 40.5597 88.368 15.0723 56.9277 15.0723C25.4874 15.0723 0 40.5597 0 72C0 103.44 25.4874 128.928 56.9277 128.928Z",
    fill: "#E6F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_996_14139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5662 47.7108H24.2891C22.1931 47.7108 20.494 49.41 20.494 51.506V131.205C20.494 133.301 22.1931 135 24.2891 135H89.5662C91.6623 135 93.3614 133.301 93.3614 131.205V51.506C93.3614 49.41 91.6623 47.7108 89.5662 47.7108Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3374 59.0964H29.6024C28.3448 59.0964 27.3253 60.1159 27.3253 61.3735C27.3253 62.6311 28.3448 63.6506 29.6024 63.6506H49.3374C50.595 63.6506 51.6145 62.6311 51.6145 61.3735C51.6145 60.1159 50.595 59.0964 49.3374 59.0964Z",
    fill: "#E6F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 68.9638H29.6024C28.3448 68.9638 27.3253 69.9833 27.3253 71.2409C27.3253 72.4985 28.3448 73.518 29.6024 73.518H63C64.2576 73.518 65.2771 72.4985 65.2771 71.2409C65.2771 69.9833 64.2576 68.9638 63 68.9638Z",
    fill: "#B3D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3374 79.5903H29.6024C28.3448 79.5903 27.3253 80.6098 27.3253 81.8674C27.3253 83.1251 28.3448 84.1445 29.6024 84.1445H49.3374C50.595 84.1445 51.6145 83.1251 51.6145 81.8674C51.6145 80.6098 50.595 79.5903 49.3374 79.5903Z",
    fill: "#E6F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89.4578H29.6024C28.3448 89.4578 27.3253 90.4773 27.3253 91.7349C27.3253 92.9925 28.3448 94.012 29.6024 94.012H63C64.2576 94.012 65.2771 92.9925 65.2771 91.7349C65.2771 90.4773 64.2576 89.4578 63 89.4578Z",
    fill: "#B3D1D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3374 100.084H29.6024C28.3448 100.084 27.3253 101.104 27.3253 102.361C27.3253 103.619 28.3448 104.639 29.6024 104.639H49.3374C50.595 104.639 51.6145 103.619 51.6145 102.361C51.6145 101.104 50.595 100.084 49.3374 100.084Z",
    fill: "#E6F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109.952H29.6024C28.3448 109.952 27.3253 110.971 27.3253 112.229C27.3253 113.487 28.3448 114.506 29.6024 114.506H63C64.2576 114.506 65.2771 113.487 65.2771 112.229C65.2771 110.971 64.2576 109.952 63 109.952Z",
    fill: "#B3D1D1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_996_14139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5662 9H24.2891C22.1931 9 20.494 10.6992 20.494 12.7952V35.5663C20.494 37.6623 22.1931 39.3614 24.2891 39.3614H89.5662C91.6623 39.3614 93.3614 37.6623 93.3614 35.5663V12.7952C93.3614 10.6992 91.6623 9 89.5662 9Z",
    fill: "#B3D1D1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3373 17.3494H29.6024C28.3448 17.3494 27.3253 18.3689 27.3253 19.6265C27.3253 20.8841 28.3448 21.9036 29.6024 21.9036H49.3373C50.5949 21.9036 51.6144 20.8841 51.6144 19.6265C51.6144 18.3689 50.5949 17.3494 49.3373 17.3494Z",
    fill: "#E6F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27.2169H29.6024C28.3448 27.2169 27.3253 28.2364 27.3253 29.494C27.3253 30.7516 28.3448 31.7711 29.6024 31.7711H63C64.2576 31.7711 65.2771 30.7516 65.2771 29.494C65.2771 28.2364 64.2576 27.2169 63 27.2169Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_996_14139",
    x: 14.494,
    y: 38.7108,
    width: 84.8675,
    height: 99.2892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_996_14139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_996_14139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_996_14139",
    x: 14.494,
    y: 0,
    width: 84.8675,
    height: 42.3615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_996_14139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_996_14139",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSurvey);
export default __webpack_public_path__ + "static/media/noSurvey.ad747ce27d19e0327d5fcd36208a699e.svg";
export { ForwardRef as ReactComponent };